import { ComponentProps, CSSProperties, FC, ReactNode } from 'react';

import { ColumnContainer } from './FlexContainer.styles';

interface Props {
	children: ReactNode;
	className?:
		| 'flexStart'
		| 'flexEnd'
		| 'center'
		| 'spaceBetween'
		| 'stretch'
		| string;
	gap?: CSSProperties['gap'];
	style?: CSSProperties | undefined;
	sx?: ComponentProps<typeof ColumnContainer>['sx'];
	testId?: string;
}

/** TODO make it possible to pass a {component} prop like in mui (see AdditionalNeedText)
 *  TODO MC-3940 fix className prop */
export const FlexColumn: FC<Props> = ({
	children,
	className = 'stretch',
	style,
	gap,
	sx,
	testId = 'flexColumn',
}) => {
	return (
		<ColumnContainer
			data-testid={testId}
			className={className}
			style={style}
			gap={gap}
			sx={sx}
		>
			{children}
		</ColumnContainer>
	);
};
